// This is a route allowlist, not authorization. Every server operation must
// independently verify the current administrator and active training marker.
export const SYNTHETIC_TRAINING_TENANT = 'c0b361df-e850-5ef3-9191-92a952eae5f6';
export const SYNTHETIC_TRAINING_NAME = 'CrediArc Synthetic Training';
export const isSyntheticTrainingTenant = tenantId => tenantId === SYNTHETIC_TRAINING_TENANT;
export const syntheticTrainingPath = `/tenant-dashboard/${SYNTHETIC_TRAINING_TENANT}/synthetic-training`;
